<div class="spinner-box">
  <bci-spinner [type]="type" class="spinner"></bci-spinner>
</div>



// WEBPACK FOOTER //
// ./src/app/core/services/loader/component/loader.component.html